export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5095.872f771d.jpg";